import "leaflet/dist/leaflet.css";
import React from "react";
import {GeoJSON, LayersControl} from "react-leaflet";
interface BucketProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  legend: string;
  legendStepMin: number;
  legendStepMax: number;
  mapDataStateFeatures: any;
  filterFeatures: (
    geoJsonFeature: any,
    minValue: number,
    maxValue: number,
  ) => boolean;
  onEachState: (feature: any, layer: any) => void;
}
const Bucket: React.FC<BucketProps> = ({
  checked,
  setChecked,
  legend,
  legendStepMin,
  legendStepMax,
  mapDataStateFeatures,
  filterFeatures,
  onEachState,
}): JSX.Element => {
  return (
    <>
      <LayersControl.Overlay checked={checked} name={legend}>
        <GeoJSON
          data={mapDataStateFeatures}
          onEachFeature={onEachState}
          filter={(geoJsonFeature) =>
            filterFeatures(geoJsonFeature, legendStepMin, legendStepMax)
          }
          eventHandlers={{
            add: (e) => {
              setChecked(true);
            },
            remove: (e) => {
              setChecked(false);
            },
          }}
        />
      </LayersControl.Overlay>
    </>
  );
};

export default Bucket;
